import {STATUS_ERROR, STATUS_LOADING} from "../const";

export default {
    isLoggedIn: state => !!state.token,
    status: state => state.status,
    user: state => state.user,
    isLoading: state => state.status === STATUS_LOADING,
    hasError: state => state.status === STATUS_ERROR,
    lastError: state => state.lastError,
    isAdmin: state => !!state.user.admin,
    isNoRula: state => state.user.noRula === false,
};
